var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Power-Point"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.4375 3.82812H11.7031V7.17969C11.7031 8.69551 12.9295 9.92188 14.4453 9.92188H17.7969V19.0625C17.7969 19.3977 17.5227 19.6719 17.1875 19.6719H7.4375C7.10234 19.6719 6.82812 19.3977 6.82812 19.0625V4.4375C6.82812 4.10234 7.10234 3.82812 7.4375 3.82812ZM13.5312 4.58603L17.039 8.09375H14.4453C13.9388 8.09375 13.5312 7.68623 13.5312 7.17969V4.58603ZM7.4375 2C6.09307 2 5 3.09307 5 4.4375V19.0625C5 20.4069 6.09307 21.5 7.4375 21.5H17.1875C18.5319 21.5 19.625 20.4069 19.625 19.0625V9.10303C19.625 8.45557 19.3698 7.83477 18.9128 7.37773L14.2435 2.71221C13.7864 2.25518 13.1694 2 12.522 2H7.4375ZM10.7891 11.75C10.2825 11.75 9.875 12.1575 9.875 12.6641V17.5391C9.875 18.0456 10.2825 18.4531 10.7891 18.4531C11.2956 18.4531 11.7031 18.0456 11.7031 17.5391V16.9297H12.7695C14.2016 16.9297 15.3594 15.7719 15.3594 14.3398C15.3594 12.9078 14.2016 11.75 12.7695 11.75H10.7891ZM12.7695 15.1016H11.7031V13.5781H12.7695C13.1885 13.5781 13.5312 13.9209 13.5312 14.3398C13.5312 14.7588 13.1885 15.1016 12.7695 15.1016Z",
    fill: "#EB7452"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.390e9eb9f0066884eb3f9d3ea2e2cbba.svg";
export { ForwardRef as ReactComponent };